import { environment } from '@env/environment';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormEmployeeReferenceComponent } from '@app/components/form-employee-reference/form-employee-reference.component';
import { FormGroupUploadBoxComponent } from '@app/components/form-group/form-group-upload-box/form-group-upload-box.component';
import { COUNTRY_LIST } from '@app/config/country.enum';
import { LANGUAGE_LEVEL } from '@app/config/language';
import { GenericFormCarouselComponent } from '@app/helpers/generic-form-carousel-component';
import { IFileUpload } from '@app/interfaces/iupload-file';
import { ConstantsService } from '@app/services/constants.service';
import { EmployeeService } from '@app/services/employee.service';
import { JobService } from '@app/services/job.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';
import { Select2OptionData } from 'ng-select2';
import { Subscription } from 'rxjs';

declare const gtag: Function;

@Component({
  selector: 'job-application-modal',
  templateUrl: './job-application-modal.component.html',
  styleUrls: ['./job-application-modal.component.css']
})
export class JobApplicationModalComponent extends GenericFormCarouselComponent {

  @Output() eventApplication = new EventEmitter<string>();
  @ViewChild('inputCriminalRecord') inputCriminalRecord: FormGroupUploadBoxComponent | null;
  @ViewChild('inputWwcRecord') inputWwcRecord: FormGroupUploadBoxComponent | null;

  @ViewChild('formReference1') formReference1: FormEmployeeReferenceComponent | null;
  @ViewChild('formReference2') formReference2: FormEmployeeReferenceComponent | null;

  public COUNTRY_LIST = COUNTRY_LIST;
  public LANGUAGE_LEVEL = LANGUAGE_LEVEL;
  private idEnglishLanguage: number = 0;

  public dataAddressSelect: Array<Select2OptionData> = []
  public jobQuestionList: Array<any> = []
  private applyJobInProgress = false;

  public _formGroupProfile: UntypedFormGroup;
  public _formGroupQuestions: UntypedFormGroup;
  public _formGroupAddress: UntypedFormGroup;
  public _formGroupConditions: UntypedFormGroup;

  public idJob: Number = 0;
  public jobPosition: string = "";
  public jobTitle: string = "";
  public jobGradeFrom: string = "";
  public jobGradeTo: string = "";
  private modalName = 'modal-apply-job';
  public employerName = "";
  public employeeConditions: boolean = true;
  public remainingReference: number = 0;

  private subscriptionEmployeeForeign: Subscription;
  public isTextRead: boolean = false;

  constructor(
    private employeeService: EmployeeService,
    private jobService: JobService,
    private userService: UserService,
    public constantsService: ConstantsService) {
    super("carousel-application");
    this._formGroupQuestions = new UntypedFormGroup({ employerQuestions: new UntypedFormArray([]) });
    this._formGroupAddress = new UntypedFormGroup({ applicationAddress: new UntypedFormControl([], [Validators.required]) });
    this._formGroupConditions = new UntypedFormGroup({ agreeForm: new UntypedFormControl(false, Validators.requiredTrue), });
    this._formGroupProfile = new UntypedFormGroup({
      employeeCriminalRecord: new UntypedFormControl('', [Validators.required]),
      employeeWwcRecord: new UntypedFormControl('', [Validators.required]),
      employeeEnglishLevel: new UntypedFormControl('', [Validators.required]),
      employeeEnglishDocument: new UntypedFormControl(''),
      employeeForeign: new UntypedFormControl(false),
      employeeNacionality: new UntypedFormControl('', [Validators.required]),
    });

    this.subscriptionEmployeeForeign = this.employeeForeign.valueChanges.subscribe(() => {

      if (this.employeeForeign.value === true) {
        this.employeeNacionality.setValidators([Validators.required]);
      }
      else {
        this.employeeNacionality.clearValidators();
      }
      this.employeeNacionality.updateValueAndValidity();
    });
  }

  public activeButtonBackReference: boolean = true;
  public activeButtonBackJobAddress: boolean = true;
  public activeButtonBackJobQuestion: boolean = true;
  public activeButtonBackJobConfirmation: boolean = true;

  setValues(
    jobAddress3: any,
    jobQuestions: any,
    employerName: string,
    id: Number,
    position: string,
    jobTitle: string,
    gradeFrom: string,
    gradeTo: string,
    conditions: Number,
    employeeCriminalRecord: string,
    employeeWwcRecord: string,
    remainingReference: any,
    employeeEnglishLevel: string,
    employeeForeign: string,
    jobYear: number
  ) {

    this.employerName = employerName;
    this.idJob = id;
    this.jobPosition = position;
    this.jobTitle = jobTitle;
    this.jobGradeFrom = gradeFrom;
    this.jobGradeTo = gradeTo;
    this.employeeConditions = conditions === 1 ? true : false;
    this.agreeForm.setValue(this.employeeConditions);

    this.remainingReference = +remainingReference > 0 ? +remainingReference : 0;

    //create new forms and reset var
    this._formGroupQuestions = new UntypedFormGroup({ employerQuestions: new UntypedFormArray([]) });
    this._formGroupAddress = new UntypedFormGroup({ applicationAddress: new UntypedFormControl([], [Validators.required]) });

    if (!(+jobYear === 2024)) {
      this.employeeCriminalRecord.disable();

      this.employeeWwcRecord.disable();

      this.employeeEnglishLevel.disable();
      this.employeeEnglishDocument.disable();

      this.employeeForeign.disable();
      this.employeeNacionality.disable();
    }
    else {

      if (employeeCriminalRecord) {
        this.employeeCriminalRecord.disable();
      }
      else {
        this.employeeCriminalRecord.setValue('');
        this.employeeCriminalRecord.enable();
      }

      if (employeeWwcRecord) {
        this.employeeWwcRecord.disable();
      }
      else {
        this.employeeWwcRecord.setValue('');
        this.employeeWwcRecord.enable();
      }

      if (employeeEnglishLevel) {
        this.employeeEnglishLevel.disable();
        this.employeeEnglishDocument.disable();
      }
      else {
        this.employeeEnglishDocument.setValue('');
        this.employeeEnglishDocument.enable();
        this.employeeEnglishLevel.setValue('');
        this.employeeEnglishLevel.enable();
      }

      if (employeeForeign) {
        this.employeeForeign.disable();
        this.employeeNacionality.disable();
      }
      else {
        this.employeeForeign.setValue(true);
        this.employeeForeign.enable();
        this.employeeNacionality.setValue('');
        this.employeeNacionality.enable();
      }
    }

    this.dataAddressSelect = [];
    this.jobQuestionList = [];
    this.applyJobInProgress = false;

    //sort the address if exists
    if (jobAddress3 && (jobAddress3 as []).length > 0) {
      var data: any = jobAddress3 as []
      data = data.sort((a: any, b: any) => a.jobAddress3.localeCompare(b.jobAddress3))
      data.forEach((e: any) => {
        this.dataAddressSelect = [...this.dataAddressSelect, {
          id: e.jobAddress3,
          text: e.jobAddress3
        }];
      });
    }

    if (this.dataAddressSelect.length === 1) { this.applicationAddress.setValue([this.dataAddressSelect[0].text]) };

    if (jobQuestions && (jobQuestions as []).length > 0) {

      this.jobQuestionList = jobQuestions as [];

      this.jobQuestionList.forEach(e => {

        this.employerQuestions.push(new UntypedFormControl("", Validators.required));
      });
    }

    this._formGroupAddress.markAsUntouched();
    this._formGroupConditions.markAsUntouched();
    this._formGroupProfile.markAsUntouched();
    this._formGroupQuestions.markAsUntouched();

    this._formGroupAddress.updateValueAndValidity();
    this._formGroupConditions.updateValueAndValidity();
    this._formGroupProfile.updateValueAndValidity();
    this._formGroupQuestions.updateValueAndValidity();

    this.helpService.modalShow(this.modalName);

    this.regenerateCarousel();

    if (this.formReference1) this.formReference1.reserValues();
    if (this.formReference2) this.formReference2.reserValues();

    this.isTextRead = false;

    this.evaluateButtonBack();

    this.scriptService.initPopover();

  }

  evaluateButtonBack() {

    this.activeButtonBackReference =
      this.employeeCriminalRecord.enabled ||
      this.employeeWwcRecord.enabled ||
      this.employeeEnglishLevel.enabled ||
      this.employeeEnglishDocument.enabled ||
      this.employeeForeign.enabled ||
      this.employeeNacionality.enabled;

    this.activeButtonBackJobAddress = this.remainingReference > 0 || this.activeButtonBackReference;
    this.activeButtonBackJobQuestion = this.dataAddressSelect.length > 1 || this.remainingReference > 0 || this.activeButtonBackReference;
    this.activeButtonBackJobConfirmation = this.jobQuestionList.length > 0 || this.dataAddressSelect.length > 1 || this.remainingReference > 0 || this.activeButtonBackReference;
  }

  validateStepQuestion(event: any) {

    event.preventDefault();

    this._formGroupQuestions.markAllAsTouched();

    if (this._formGroupQuestions.invalid) return;

    this.nextStepCarousel();
  }

  applyJob(event: any) {

    event.preventDefault();

    this._formGroupProfile.markAllAsTouched();
    this._formGroupConditions.markAllAsTouched();
    if (this._formGroupConditions.invalid) { return; }
    if (this.applyJobInProgress === true) { return; }

    this.applyJobInProgress = true;

    var arrParam: Array<any> = [];

    for (let index = 0; index < this.employerQuestions.length; index++) {

      arrParam.push({ _id: this.jobQuestionList[index]._idJobQuestion, employeeAnswer: this.employerQuestions.at(index).value });
    }

    let req = {
      _idJob: this.idJob,
      _idUser: this.userService.getIdCurrentUser(),
      _idEmployee: this.userService.getIdEmployee(),
      jobAnswer: arrParam,
      jobAddress: this.applicationAddress.value,
      agreeCondition: this.agreeForm.value
    };



    this.jobService.applyJob(req).toPromise().then(res => {

      switch (res.status_code) {

        case 0:
          this.showStepSuccess();

          if (environment.production === true)
            gtag('event', 'Job Application', { 'event_category': 'Form Submit' });

          this.eventApplication.next("APPLICATION SENT");
          break;

        case 2:
          this.showStepError(res);
          this.eventApplication.next("APPLICATION SENT");
          break;

        default:
          this.showStepError(res);
          break;
      }

      this.applyJobInProgress = false;

    },
      err => {
        console.error(err);
        this.showStepError();
        this.applyJobInProgress = false;
      }
    )
  }


  validateStepApplicationAddress(event: any) {

    event.preventDefault();

    this._formGroupAddress.markAllAsTouched();

    if (this._formGroupAddress.invalid) return;

    this.nextStepCarousel();
  }

  validateStepProfile(event: any) {

    event.preventDefault();

    this._formGroupProfile.markAllAsTouched();

    if (this._formGroupProfile.invalid) return;

    this.nextStepCarousel();

    if (this.employeeForeign.enabled) {


      const req = {
        employeeForeign: this.employeeForeign.value === true ? 1 : 0,
        employeeNacionality: this.employeeNacionality.value,

      }

      this.employeeService.putEmployeeProfileApplication(this.userService.getIdEmployee(), req).toPromise().then(
        res => {

        });
    }

    if (this.employeeEnglishLevel.enabled) {

      let req = {
        _idEmployee: this.userService.getIdEmployee(),
        languageName: 'Inglés',
        languageLevel: this.employeeEnglishLevel.value,
        languageDocument: this.employeeEnglishDocument.value
      };

      this.employeeService.saveLanguage(this.idEnglishLanguage, req).toPromise().then(res => {
        if (this.idEnglishLanguage === 0)
          this.idEnglishLanguage = res._id;
      },
        err => {
          console.error(err);
        }
      );
    }





  }

  onEventFileUpload(event: IFileUpload) {

    const req =
    {
      _idEmployee: this.userService.getIdEmployee(),
      type: event.type,
      path: event.path,
      name: event.name
    };

    this.employeeService.postFile(req).toPromise().then(
      res => {

        if (res.status_code !== status_code.success) {
          return;
        }

      }
    );
  }

  ngOnDestroy() {
    if (this, this.subscriptionEmployeeForeign) { this.subscriptionEmployeeForeign.unsubscribe(); }
  }

  onClickWhastappLater() {
    if (environment.production === true) {
      gtag('event', 'Button WS community', { 'event_category': 'Click', 'event_label': 'Later' });
    }
  }

  onClickWhastapp() {
    if (environment.production === true) {
      gtag('event', 'Button WS community', { 'event_category': 'Click', 'event_label': 'Open' });
    }
  }



  get applicationAddress() { return this._formGroupAddress.get('applicationAddress') as UntypedFormControl; }
  get employerQuestions() { return this._formGroupQuestions.get('employerQuestions') as UntypedFormArray; }
  get agreeForm() { return (this._formGroupConditions.get('agreeForm') as UntypedFormControl); }
  get employeeCriminalRecord() { return (this._formGroupProfile.get('employeeCriminalRecord') as UntypedFormControl); }
  get employeeWwcRecord() { return (this._formGroupProfile.get('employeeWwcRecord') as UntypedFormControl); }
  get employeeEnglishLevel() { return this._formGroupProfile.get('employeeEnglishLevel') as UntypedFormControl; }
  get employeeEnglishDocument() { return this._formGroupProfile.get('employeeEnglishDocument') as UntypedFormControl; }
  get employeeForeign() { return this._formGroupProfile.get('employeeForeign') as UntypedFormControl; }
  get employeeNacionality() { return this._formGroupProfile.get('employeeNacionality') as UntypedFormControl; }
}
